(function () {
  if (window.__nestMrcAuditNoteReconciler20260703) return;
  window.__nestMrcAuditNoteReconciler20260703 = true;

  var feeVariantId = 39273096544337;
  var timer = null;
  var running = false;
  var selfUpdating = false;

  function mark(name, detail) {
    if (window.NestLreCartTiming && typeof window.NestLreCartTiming.mark === 'function') {
      window.NestLreCartTiming.mark(name, detail);
    }
  }

  function isMattressDecisionFlowPage() {
    var path = window.location && window.location.pathname ? window.location.pathname.toLowerCase() : '';
    return /\/products\/[^/]*(sparrow|starling|owl)[^/]*mattress/.test(path);
  }

  function itemTitle(item) {
    return String(item.product_title || item.title || '').toLowerCase();
  }

  function itemProperties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function isMrcFee(item) {
    var props = itemProperties(item);
    return Number(item.variant_id) === feeVariantId ||
      String(props.type || '').toLowerCase() === 'fee' ||
      itemTitle(item).indexOf('mrc recycling fee') > -1 ||
      itemTitle(item).indexOf('mattress recycling fee') > -1;
  }

  function isCompanionItem(item) {
    var title = itemTitle(item);
    return isMrcFee(item) ||
      title.indexOf('lifetime renewal exchange') > -1 ||
      title.indexOf('extend protection') > -1 ||
      title.indexOf('protection plan') > -1;
  }

  function hasPrimaryProduct(cart) {
    return !!(cart && cart.items || []).some(function (item) {
      return Number(item.quantity || 0) > 0 && !isCompanionItem(item);
    });
  }

  function mrcFeeCents(cart) {
    return (cart && cart.items || []).reduce(function (sum, item) {
      if (!isMrcFee(item)) return sum;
      return sum + Number(item.final_line_price || 0);
    }, 0);
  }

  function cleanMrcNote(note) {
    if (!note) return '';
    return String(note).split(/\r?\n/).filter(function (line) {
      var lowered = line.toLowerCase();
      return lowered.indexOf('recycling fee') === -1 && lowered.indexOf('mrc:') === -1;
    }).join('\n').trim();
  }

  function desiredAuditLine(cart) {
    var cents = mrcFeeCents(cart);
    if (!cents || !hasPrimaryProduct(cart)) return '';
    var amount = (cents / 100).toFixed(2);
    var codeAmount = String(Math.round(cents / 100));
    return 'Recycling Fee: $' + amount + ' | MRC:111111-' + codeAmount + '-CA';
  }

  function desiredNote(cart) {
    var auditLine = desiredAuditLine(cart);
    if (!auditLine) return null;
    var cleaned = cleanMrcNote(cart.note);
    return cleaned ? cleaned + '\n' + auditLine : auditLine;
  }

  function reconcile(reason) {
    if (!isMattressDecisionFlowPage() || running || selfUpdating || !window.fetch) return;
    running = true;
    mark('MRC audit note reconcile check', reason || 'scheduled');

    window.fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var nextNote = desiredNote(cart);
        if (nextNote === null || nextNote === cart.note) return null;

        selfUpdating = true;
        mark('MRC audit note corrected', { from: cart.note || '', to: nextNote });
        return window.fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: nextNote })
        }).then(function (response) {
          if (!response.ok) throw new Error('MRC audit note correction failed: ' + response.status);
          return response.json();
        }).then(function (updatedCart) {
          mark('MRC audit note correction complete', updatedCart.note || '');
          return updatedCart;
        }).finally(function () {
          window.setTimeout(function () { selfUpdating = false; }, 500);
        });
      })
      .catch(function (error) {
        mark('MRC audit note correction error', error && error.message ? error.message : String(error));
      })
      .then(function () {
        running = false;
      });
  }

  function schedule(reason, delay) {
    if (!isMattressDecisionFlowPage()) return;
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      timer = null;
      reconcile(reason);
    }, typeof delay === 'number' ? delay : 900);
  }

  function isCartMutationUrl(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)\.js/.test(url);
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__nestMrcAuditNoteReconcilerPatched20260703) return;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : input && input.url;
      return originalFetch.apply(this, arguments).then(function (response) {
        if (!selfUpdating && isCartMutationUrl(url)) schedule('after fetch ' + url, 900);
        return response;
      });
    };
    window.fetch.__nestMrcAuditNoteReconcilerPatched20260703 = true;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.prototype.__nestMrcAuditNoteReconcilerPatched20260703) return;
    var proto = window.XMLHttpRequest.prototype;
    var originalOpen = proto.open;
    var originalSend = proto.send;

    proto.open = function (method, url) {
      this.__nestMrcAuditNoteUrl20260703 = String(url || '');
      return originalOpen.apply(this, arguments);
    };

    proto.send = function () {
      var xhr = this;
      var url = xhr.__nestMrcAuditNoteUrl20260703;
      if (!selfUpdating && isCartMutationUrl(url)) {
        xhr.addEventListener('loadend', function () {
          schedule('after xhr ' + url, 900);
        });
      }
      return originalSend.apply(this, arguments);
    };

    proto.__nestMrcAuditNoteReconcilerPatched20260703 = true;
  }

  function init() {
    if (!isMattressDecisionFlowPage()) return;
    patchFetch();
    patchXhr();
    schedule('initial', 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();